import { render, staticRenderFns } from "./ApiDataError.vue?vue&type=template&id=244cf249&"
import script from "./ApiDataError.vue?vue&type=script&lang=js&"
export * from "./ApiDataError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports